import React from "react";
import styled from "styled-components";
import { COLORS, LIGHT_THEME_COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import * as mediaQuery from "components/MediaQuery";
import { Option } from "utils/options";

export default function Tabs({
  tabs,
  onChangeTab,
  currentTab,
}: {
  tabs: Option[];
  onChangeTab: (value: string) => void;
  currentTab: string;
}) {
  return (
    <TabsWrapper className="tabs-wrapper">
      {tabs.map((tab: Option) => {
        return (
          <Tab
            key={tab.label}
            isSelected={tab.value === currentTab}
            onClick={() => onChangeTab(tab.value)}
            className="tab"
            data-testid={`atoms-tabs-atoms-tab-${tab.value}`}
          >
            {tab.label}
          </Tab>
        );
      })}
    </TabsWrapper>
  );
}

const TabsWrapper = styled.ul`
  ${FLEX.FlexStartStart};
  background-color: ${({ theme }) =>
    theme.value === "light" ? theme.COLORS.LIGHTGRAY : theme.COLORS.SIDEBARBG};
  border-radius: 2px;
  overflow: hidden;
  li {
    position: relative;
    + li::before {
      content: "";
      position: absolute;
      top: 10px;
      bottom: 10px;
      left: 0;
      width: 1px;
      background-color: ${({ theme }) =>
        theme.value === "light"
          ? COLORS.BUTTONS1
          : LIGHT_THEME_COLORS.BUTTONS3};
    }
  }
  ${mediaQuery.isMobile} {
    width: 100%;
    li {
      flex: 1;
    }
  }
`;

const Tab = styled.li<{ isSelected: boolean }>`
  cursor: pointer;
  color: ${({ theme, isSelected }) =>
    !isSelected ? `${theme.COLORS.WHITE}AA` : COLORS.WHITE};
  padding: 0 24px;
  ${({ isSelected }) =>
    isSelected &&
    `
    border-radius: 2px;
    + li::before, &:before {
      display: none !important;
    }
    `}
  ${FLEX.FlexCenterCenter};
  text-align: center;
  height: 34px;

  background-color: ${({ theme, isSelected }) =>
    isSelected
      ? theme.value === "light"
        ? COLORS.BUTTONS1
        : LIGHT_THEME_COLORS.BUTTONS3
      : theme.value === "light"
      ? theme.COLORS.LIGHTGRAY
      : theme.COLORS.SIDEBARBG};

  ${({ isSelected }) =>
    isSelected &&
    `
      font-weight: 500;
    `}
`;
